/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Event_Style_Summary_Style_AriaInputs */

const en_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caption style: ${i?.label}`)
};

const fr_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Style de légende : ${i?.label}`)
};

const de_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenstil: ${i?.label}`)
};

const it_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stile didascalia: ${i?.label}`)
};

const ru_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Стиль подписи: ${i?.label}`)
};

const es_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estilo de leyenda: ${i?.label}`)
};

const zh_cn2_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`标题样式：${i?.label}`)
};

const ja_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`キャプションスタイル: ${i?.label}`)
};

const hi_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कैप्शन शैली: ${i?.label}`)
};

const pt_pt2_event_style_summary_style_aria = /** @type {(inputs: Event_Style_Summary_Style_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estilo da legenda: ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Caption style: {label}" |
*
* @param {Event_Style_Summary_Style_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_style_summary_style_aria = /** @type {((inputs: Event_Style_Summary_Style_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Style_Summary_Style_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_style_summary_style_aria(inputs)
	if (locale === "de") return de_event_style_summary_style_aria(inputs)
	if (locale === "it") return it_event_style_summary_style_aria(inputs)
	if (locale === "ru") return ru_event_style_summary_style_aria(inputs)
	if (locale === "es") return es_event_style_summary_style_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_event_style_summary_style_aria(inputs)
	if (locale === "ja") return ja_event_style_summary_style_aria(inputs)
	if (locale === "hi") return hi_event_style_summary_style_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_event_style_summary_style_aria(inputs)
	return en_event_style_summary_style_aria(inputs)
});